import { useEffect } from "react";
import { singleCampaignDataAsync } from "../../../store/features/EventManage/Campaigns/CampaignApi";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { ModalType } from "../../../types";

import { Form, FormProps } from "antd";
import { GetSingleCampaignData } from "../../../types/eventManage/campaigns";
import DateCard from "../../ui/DateCard";
import FormModal from "../../ui/FormModal";

type Props = {
  open: ModalType;
  handleClose: () => void;
};

export default function CampaignView({ open, handleClose }: Props) {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { singleCampaignData } = useAppSelector((state) => state.campaigns);
  const viewData = singleCampaignData as GetSingleCampaignData;

  const onFinish: FormProps<any>["onFinish"] = (values) => {};

  useEffect(() => {
    dispatch(
      singleCampaignDataAsync({
        params: {
          id: open?.data?.campaignId,
        },
      })
    );
  }, [dispatch, open?.data?.campaignId]);

  return (
    <FormModal
      disabled={false}
      open={open?.open}
      onFinish={onFinish}
      handleClose={handleClose}
      hideBtn={true}
      showDraft={false}
      buttonText="Update"
      formProps={{
        form,
      }}
      title="Campaigns View"
      width={772}
    >
      <>
        <div className=" h-[142px] justify-start items-start gap-3 inline-flex">
          <DateCard
            start_date={viewData?.campaignStartDate}
            title={viewData?.campaignTitle}
            end_date={viewData?.campaignEndDate}
            organized_by={viewData?.campaignOrganizedBy}
            hosted_by={viewData?.campaignHostBy}
            campaign_Address={viewData?.campaignAddress}
          />
        </div>

        {/* <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-2.5 mt-4">
          {singleCampaignData?.userId?.map((val: any) => (
            <GuestCard
              designation={val?.designation}
              image={val?.photo}
              name={val?.fullName}
              profession={val?.profession}
            />
          ))}
        </div> */}
      </>
    </FormModal>
  );
}
